import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {SupplierNotesPage} from "./-page/supplier-notes.page";
import {SupplierNotesPending} from "./-page/supplier-notes.pending";
import {supplierNotesSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/engineering/suppliers/$supplierId/notes/")({
  component: RouteComponent,
  pendingComponent: SupplierNotesPending,
  staticData: {meta: {labelDescriptor: routeMessages.notes}},
  validateSearch: (search) => supplierNotesSearchSchema.parse(search),
});

function RouteComponent() {
  const {supplierId} = useParams({strict: false}) as {supplierId: string};
  const {includeDeleted} = Route.useSearch();

  return <SupplierNotesPage supplierId={supplierId} includeDeleted={includeDeleted} />;
}
